module.exports = __webpack_public_path__ + "static/media/continuous-integration.0587a63c.png";